import { c as _c } from "react/compiler-runtime";
import Script from "next/script";
import { DV360_FLOODLIGHT_CONFIG_ID, shouldLoadDv360Floodlight } from "@/lib/dv360Floodlight";

/**
 * Global gtag.js snippet for DC-16638578 (required for Floodlight activity tags).
 */
export function Dv360FloodlightGlobal() {
  const $ = _c(1);
  if (!shouldLoadDv360Floodlight()) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><Script src={`https://www.googletagmanager.com/gtag/js?id=${DV360_FLOODLIGHT_CONFIG_ID}`} strategy="afterInteractive" /><Script id="dv360-floodlight-gtag-init" strategy="afterInteractive">{`
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', '${DV360_FLOODLIGHT_CONFIG_ID}', { 'conversion_linker': false });
`}</Script></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}